// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hjuaX","index":"styles_index__14Fax"};